// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1_JL7","cls2":"CreateSocialItemModal-cls2_CPT CreateSocialItemModal-cls1_JL7"};